<div class="notification-templates">
  <div class="close-button">
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="activeModal.dismiss('Cross click')"></button>
  </div>
  <div class="header">
    <h5>Choose {{ isEmail ? 'Email' : 'SMS' }} Template</h5>
  </div>
  <div class="search-form">
    <div class="form-group mb-4">
      <label for="notificationType" class="form-label">Notification Name</label>
      <input
        type="text"
        class="form-control"
        id="templateName"
        placeholder="Search"
        [formControl]="searchFormControl" />
    </div>
  </div>
  <div class="templates">
    <div
      class="spinner-border text-primary"
      role="status"
      *ngIf="loadingTemplates; else notificationTemplates">
      <span class="visually-hidden">Loading...</span>
    </div>
    <ng-template #notificationTemplates>
      <div class="row g-3" *ngIf="uniqueTemplateNames.length > 0">
        <div
          [class]="getResponsiveColumnClass()"
          *ngFor="let template of uniqueTemplateNames">
          <div class="card">
            <div class="card-body">
              <div
                class="card-text"
                [innerHTML]="
                  template.stringifiedTemplate ?? '' | safeHtml
                "></div>

              <button
                class="btn btn-primary d-flex align-items-center mt-3 float-end"
                (click)="selectTemplate(template)">
                <span>Use</span>
                <i class="fas fa-arrow-right ms-2"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-center mt-4">
          <irembogov-pagination
            [collectionSize]="pagination.totalItems"
            [pageSizes]="[30, 60, 100]"
            (paginatedValues)="
              onPaginationChange($event)
            "></irembogov-pagination>
        </div>
      </div>
      <div
        class="d-flex justify-content-center"
        *ngIf="uniqueTemplateNames.length === 0"
        style="color: #bebebe">
        <p>No templates found.</p>
      </div>
    </ng-template>
  </div>
</div>
